import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'SharedFile/byContact';

export function useContactFilesQuery({
	contactId,
	pageSize = 25,
	enabled = true,
}: {
	contactId: string;
	pageSize?: number;
	enabled?: boolean;
}) {
	const userSession = useUserSession();

	return useInfiniteQuery<Api.IPagedCollection<Api.ISharedFile>>({
		enabled: enabled && !!contactId,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ISharedFile>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageSize, pageToken: pageParam },
					urlPath: `SharedFile/byContact/${contactId}`,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, contactId, pageSize],
		initialPageParam: '',
		meta: {
			toastErrorMessage: 'Failed to load files',
			errorLogging: { action: 'ContactFiles/loadFiles' },
		},
	});
}
